export default "/assets/images/exploding-head.png?3e93b5509e56ba95417f33247a29ab15";